<template>
  <v-dialog v-model="dialog.create" persistent max-width="50%">
    <v-card>
      <v-card-title class="subheading font-weight-bold"
        >Enviar E-mail</v-card-title
      >
      <v-divider></v-divider>

      <v-list dense>
        <v-list-item>
          <!-- <v-list-item-content>Usuário(a):</v-list-item-content> -->
          <v-list-item-content>Para: {{ email }}</v-list-item-content>
          <!-- <v-list-item-content>Para: {{ details.email }}</v-list-item-content> -->
        </v-list-item>

        <v-list-item>
          <v-list-item-content>Data da criação:</v-list-item-content>
          <v-list-item-content>{{
            new Date().toLocaleDateString()
          }}</v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-menu
              ref="picker"
              v-model="picker"
              :close-on-content-click="false"
              :return-value.sync="data_prev_conclusao"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="data_prev_conclusao"
                  label="Previsão de conclusão"
                  :disabled="!!primeiraTratativa"
                  :clearable="!primeiraTratativa"
                  persistent-hint
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="pt-BR"
                v-model="data_prev_conclusao"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="picker = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.picker.save(data_prev_conclusao)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-text-field
              label="Titulo do email"
              v-model="subject"
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-textarea label="Tratativa" v-model="tratativa"></v-textarea>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" :loading="loading" text @click="close()"
          >Cancelar</v-btn
        >
        <v-btn
          color="green darken-1"
          text
          @click="send()"
          :loading="loading"
          :disabled="!tratativa || !data_prev_conclusao || !subject"
          >Enviar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Create",

  props: {
    details: {
      type: Object,
      required: true,
    },
    // comentario_do_pedido: {
    //   default: "",
    //   type: String,
    // },
  },

  data: () => ({
    picker: false,
    id: "",
    data_trat: new Date(),
    data_prev_conclusao: null,
    email: "",
    tratativa: "",
    subject: "",
    id_status: "1",
    id_tipo: "2",
    loading: false,
  }),

  computed: {
    ...mapState(["timeline", "dialog", "details"]),

    primeiraTratativa() {
      return this.timeline[0];
    },

    tratativa() {
      return this.getTimeline();
    },

    chatEmail() {
      let email = "";
      let email_remetente = "";

      return [...this.timeline].reverse().reduce((acc, item) => {
        if (item.email !== email) {
          email = item.email;

          // acc.push("<hr>");
        }
        if (item.ID_TIPO !== 3) {
          email_remetente = item.EMAIL_LOJA;
        } else {
          email_remetente = item.email;
        }

        if (item.ID_TIPO === 1) {
          // console.log("ooi");
          return acc;
        } else {
          acc.push(
            `<strong>De:</strong> ${email_remetente}
          <br/>
          <strong>Enviada em:</strong> ${new Date(
            item.data_trat
          ).toLocaleDateString()}
          <br/>
         
          <strong>Assunto:</strong> ${this.details.comentario_do_pedido}

          <p><strong>
          Mensagem:</strong> ${item.tratativa}</p>
          
          <hr>`
          );

          return acc;
        }
      }, []);
    },
  },

  watch: {
    primeiraTratativa: {
      handler(newValue) {
        if (newValue) {
          const date = new Date(newValue.data_prev_conclusao);
          this.data_prev_conclusao = `${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
        }
      },
      immediate: true,
    },

    chatEmail() {
      let email = "";
      let email_remetente = "";

      return [...this.timeline].reverse().reduce((acc, item) => {
        if (item.email !== email) {
          email = item.email;

          acc.push("<hr>");
        }

        if (item.ID_TIPO !== 3) {
          email_remetente = item.EMAIL_LOJA;
        } else {
          email_remetente = item.email;
        }

        if (item.ID_TIPO === 1) {
          // console.log("PASSEI AQUI!");
          // console.log("PASSEI AQUI ACC:", acc);
          return acc;
        } else {
          acc.push(
            `<strong>De:</strong> ${email_remetente}
          <br/>
          <strong>Enviada em:</strong> ${new Date(
            item.data_trat
          ).toLocaleDateString()}
          <br/>
         
          <strong>Assunto:</strong> ${this.details.comentario_do_pedido}

          <p><strong>
          Mensagem:</strong> ${item.tratativa}</p>
          
          <hr>`
          );
          // console.log("PASSEI AQUI TAMBEM!");
          // console.log("PASSEI AQUI TAMBEM ACC:", acc);
          return acc;
        }
      }, []);
    },

    // tratativa: {
    //   handler() {
    //     this.loadData();
    //   },
    //   deep: true,
    // },
  },

  methods: {
    ...mapMutations(["setDialog"]),
    ...mapActions(["getTimeline", "getData"]),

    close() {
      this.setDialog({ dialog: { create: false } });
      this.tratativa = "";
      // console.log(this.EMAIL_LOJA);
      // console.log(this.marca);
      // console.log(this.nome);
      // console.log(this.comentario_do_pedido);
    },

    // loadData() {
    //   console.log("TEM ATUALIZAÇÃO");
    //   // this.loading = true;
    //   // this.getTimeline();
    // },

    sendEmailNotification(msg) {
      fetch(
        "https://se7uaeoabd.execute-api.us-east-1.amazonaws.com/dev/sendEmail",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(msg),
        }
      );
      // let url =
      //   "https://se7uaeoabd.execute-api.us-east-1.amazonaws.com/dev/sendEmail";
      // let headers = {
      //   "Content-type": "application/json",
      //   Accept: "application/json",
      // };
      // axios({ url, headers, data: msg, method: "post" });
      // .then((response) => {
      //   console.log(response);
      // })
      // .catch((error) => {
      //   console.log(error);
      // });
    },

    send() {
      this.loading = true;
      fetch(
        "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev/tratativa",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: process.env.VUE_APP_AUTHORIZATION,
          },
          body: JSON.stringify(
            {
              id: this.id,
              data_trat: this.data_trat.toISOString(),
              data_prev_conclusao: this.$options.filters
                .formatDate(this.data_prev_conclusao)
                .toISOString(),
              email: this.email,
              tratativa: this.tratativa,
              id_status: this.id_status,
              id_tipo: this.id_tipo,
            }
            // console.log(
            //   JSON.stringify({
            //     email: this.email,
            //     tratativa: this.tratativa,
            //     id_status: this.id_status,
            //     id_tipo: this.id_tipo,
            //   })
            // )
          ),
        }
      ).finally(() => {
        this.loading = false;
        const base64 = require("base-64");
        const cryptoId = base64.encode(JSON.stringify(this.id));
        const msg = {
          // to: this.email,
          to: this.email,
          from: `${this.details.marca
            .split(" ")
            .join("")}@survey.questmanager.com`,
          subject: `${this.subject}`,
          html: `<p>Olá ${
            this.details.nome
          }, tudo bem?<br><br>Estamos entrando em contato em relação a sua participação na nossa pesquisa, referente a compra realizada no dia <strong>${this.details.data_da_entrevista.slice(
            8,
            -14
          )}/${this.details.data_da_entrevista.slice(
            5,
            -17
          )}/${this.details.data_da_entrevista.slice(
            0,
            -20
          )}</strong> no <strong>(${this.details.marca} - ${
            this.details.loja
          })</strong>, no qual você escreveu: 

          <br><br> 

          <strong>Seu comentário sobre ${this.details.marca}: </strong>${
            this.details.comentario_da_causa
          }</p> 

          <p> <strong>Resposta do ${this.details.marca}: </strong>${
            this.tratativa
          }</p>
          
          <a href="https://chatdev.d1s1o66eajshb7.amplifyapp.com/#/chat/${cryptoId}">Clique aqui e responda a mensagem do nosso suporte</a> 
          <hr> 
          ${this.chatEmail.join("")}`,
        };
        this.sendEmailNotification(msg);
        this.close();
        this.getTimeline();
        this.getData();
      });
    },
  },

  filters: {
    date: (str) => new Date(str),
    formatDate: (str) => {
      if (str) {
        const date = [...str.split("-")];
        const day = parseInt(date[2]);
        const year = parseInt(date[0]);
        const month = parseInt(date[1]) - 1;

        if (day < 10) {
          return new Date(year, month, day);
        }

        return new Date(year, month, day);
      } else return "";
    },
  },

  mounted() {
    this.id = this.details.id;
    this.email = this.details.email;
    // console.log(this.details.marca.split(" ").join(""));
  },
};
</script>
